import type { PopoverOrigin } from "@mui/material";

import appConfig from "config/appConfig";

import { MenuListPositionOpts } from "shared/uikit/types";

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const uuidv4 = (): string => {
	// @ts-expect-error: special code
	return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
		// @ts-expect-error: special code
		(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
	);
};

export const safelyParseJSON = <T>(json: string): T => {
	let parsed;

	try {
		parsed = JSON.parse(json);
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
	} catch (err) {
		// It's ok
	}

	return parsed as T;
};

export const makeId = (length = 5) => {
	let result = "";
	const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	const charactersLength = characters.length;
	let counter = 0;
	while (counter < length) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
		counter += 1;
	}
	return result;
};

export function randomInteger(min: number, max: number) {
	return Math.floor(Math.random() * (max - min)) + min;
}

export const filterFiles = (files: FileList, types: string[]): FileList => {
	const dt = new DataTransfer();
	const correctTypes = types.map(x => (x.includes("/*") ? x.replace("/*", "/") : x));
	Array.from(files).forEach(file => {
		if (correctTypes.some(x => file.type.startsWith(x))) {
			dt.items.add(file);
		}
	});
	return dt.files;
};

export const getAnchorOriginPos = (contentPosition: MenuListPositionOpts): PopoverOrigin => {
	switch (contentPosition) {
		case MenuListPositionOpts.TOP_LEFT:
			return { vertical: "top", horizontal: "left" };

		case MenuListPositionOpts.TOP_RIGHT:
			return { vertical: "top", horizontal: "right" };

		case MenuListPositionOpts.TOP_CENTER:
			return { vertical: "top", horizontal: "center" };

		case MenuListPositionOpts.BOTTOM_LEFT:
			return { vertical: "bottom", horizontal: "left" };

		case MenuListPositionOpts.BOTTOM_RIGHT:
			return { vertical: "bottom", horizontal: "right" };

		default:
			return {
				vertical: "bottom",
				horizontal: "center"
			};
	}
};

export const getTransformOriginPos = (popoverPosition: MenuListPositionOpts): PopoverOrigin => {
	switch (popoverPosition) {
		case MenuListPositionOpts.TOP_LEFT:
			return { vertical: "top", horizontal: "left" };

		case MenuListPositionOpts.TOP_RIGHT:
			return { vertical: "top", horizontal: "right" };

		case MenuListPositionOpts.TOP_CENTER:
			return { vertical: "top", horizontal: "center" };

		case MenuListPositionOpts.BOTTOM_LEFT:
			return { vertical: "bottom", horizontal: "left" };

		case MenuListPositionOpts.BOTTOM_RIGHT:
			return { vertical: "bottom", horizontal: "right" };

		default:
			return {
				vertical: "bottom",
				horizontal: "center"
			};
	}
};

export const compareObjects = (o1: any, o2: any) => {
	for (const p in o1) {
		if (o1.hasOwnProperty(p)) {
			if (o1[p] !== o2[p]) {
				return false;
			}
		}
	}
	for (const p in o2) {
		if (o2.hasOwnProperty(p)) {
			if (o1[p] !== o2[p]) {
				return false;
			}
		}
	}
	return true;
};

export const groupBy = (xs: any[], key: string) =>
	xs.reduce((rv, x) => {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	}, {});

export const parseNameToFirstLastName = (name?: null | string) => {
	if (!name) return undefined;
	const parts = name.trim().split(/\s+/);
	return {
		firstName: parts[0],
		lastName: parts.length > 1 ? parts[parts.length - 1] : undefined
	};
};

export const shortAddress = (address: string, counts = 4) => {
	return `${address.slice(0, counts)}...${address.slice(address.length - counts, address.length)}`;
};

export const getAzureStoreLink = (container: string, imgName: string) => {
	if (imgName.startsWith("http")) {
		return imgName;
	}
	return `${appConfig.GLOBAL_CONSTANTS.AZURE_STORAGE_URL}/${container}/${imgName}`;
};
